import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, Cell, ReferenceLine } from "recharts";
import { utilizationFillColor } from "@/lib/calc";

// Hoisted out of render — these are static recharts style objects.
const TICK_STYLE = { fontSize: 11, fill: "#69747C" };
const AXIS_LINE_STYLE = { stroke: "#E4DFD2" };
const TOOLTIP_CURSOR = { fill: "rgba(31,35,38,0.04)" };
const CHART_MARGIN = { top: 12, right: 8, bottom: 8, left: -16 };
const BAR_RADIUS = [6, 6, 0, 0];
const Y_DOMAIN = [0, (dataMax) => Math.max(120, Math.ceil(dataMax / 20) * 20)];
const tickFormatter = (v) => `${v}%`;

const CustomTooltip = ({ active, payload }) => {
  if (!active || !payload?.length) return null;
  const d = payload[0].payload;
  return (
    <div className="bg-white border border-[#E4DFD2] rounded-lg px-3 py-2 shadow-md text-xs">
      <div className="font-semibold text-[#1F2326]">{d.full}</div>
      <div className="text-[#69747C] mt-0.5">
        {d.logged_hours}h logged of {d.included_hours}h ({d.utilization.toFixed(0)}%)
      </div>
    </div>
  );
};

const UtilizationChart = ({ clients }) => {
  const data = (clients || []).map((c) => ({
    name: c.name.length > 14 ? c.name.slice(0, 13) + "." : c.name,
    full: c.name,
    utilization: c.utilization_pct,
    logged_hours: c.logged_hours,
    included_hours: c.included_hours,
  }));

  if (data.length === 0) {
    return (
      <div className="h-64 flex items-center justify-center text-sm text-[#69747C]">
        No retainers yet. Add one to see utilization.
      </div>
    );
  }

  return (
    <div className="h-72 min-h-[200px] w-full" data-testid="utilization-chart">
      <ResponsiveContainer width="100%" height="100%" minWidth={0} minHeight={200}>
        <BarChart data={data} margin={CHART_MARGIN}>
          <XAxis
            dataKey="name"
            stroke="#A9A294"
            tick={TICK_STYLE}
            tickLine={false}
            axisLine={AXIS_LINE_STYLE}
          />
          <YAxis
            stroke="#A9A294"
            tick={TICK_STYLE}
            tickLine={false}
            axisLine={false}
            tickFormatter={tickFormatter}
            domain={Y_DOMAIN}
          />
          <Tooltip content={<CustomTooltip />} cursor={TOOLTIP_CURSOR} />
          <ReferenceLine y={86} stroke="#C99A4A" strokeDasharray="3 3" />
          <ReferenceLine y={100} stroke="#C76055" strokeDasharray="3 3" />
          <Bar dataKey="utilization" radius={BAR_RADIUS}>
            {data.map((d) => (
              <Cell key={d.full} fill={utilizationFillColor(d.utilization)} />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default UtilizationChart;
